export default __webpack_public_path__ + "static/media/fad-next.8ca920ee.svg";